



export const capitalizarPalabras = (texto) => {
    return texto
        .toLowerCase()
        .split(' ')
        .map(palabra => palabra.charAt(0).toUpperCase() + palabra.slice(1))
        .join(' ');
};




export const coloresTipo = {
    VENTA: '#388E3C',
    MORTALIDAD: '#D32F2F',
    TRASLADO: '#FFA000',
    DESCUENTO: '#616161',
};



export const coloresTipoNoti = {
    PENDIENTE: '#9E9E9E', 
    DENEGADA: '#D32F2F',    
    ACEPTADA: '#388E3C',
};



export const colorPorNumero = (valor) => {
    if (valor > 0) return '#388E3C';
    if (valor < 0) return '#D32F2F';
    return '#000000'; 
};